import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, Validators } from '@angular/forms';

@Directive({
  selector: '[appEmailValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true }]
})
export class EmailDirective implements Validator {
  // @Input('appEmail') valueToCheck: string;
  constructor() { }
  validate(control: AbstractControl): {[key: string]: any} {

    if(!control.value) return null;
    if(control.value.toLowerCase() === "direct order") return null;
    let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    
    let passed : boolean = false;
    if(control.value.split(';').length > 1){
      let parts = control.value.split(';');
      let maps = parts.map(email => Validators.email(<AbstractControl>{value: email}));
      passed = maps.find(_ => { return _ !== null ;}) == undefined;
    }
    else if(control.value.split(',').length > 1){
      let parts = control.value.split(',');
      let maps = parts.map(email => Validators.email(<AbstractControl>{value: email}));
      passed = maps.find(_ => { return _ !== null ;}) == undefined;
    }
    else 
      passed = Validators.email(control) == null ? true : false
    return passed ? null : { 'failedEmailRegex': true }
  }
}
